import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

// Easing function for a smoother animation
const easeOutQuad = t => t * (2 - t);

const AnimatedCounter = ({ endValue, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  
  // 'ref' is the element to track, 'inView' is a boolean for visibility
  const { ref, inView } = useInView({
    triggerOnce: true, // Animate only once when it comes into view
    threshold: 0.1,    // Trigger when 10% of the element is visible
  });

  useEffect(() => {
    if (inView) {
      let startTime;
      const animateCount = (timestamp) => {
        if (!startTime) {
          startTime = timestamp;
        }
        
        const elapsedTime = timestamp - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easedProgress = easeOutQuad(progress);
        
        setCount(Math.floor(easedProgress * endValue));

        if (progress < 1) {
          requestAnimationFrame(animateCount);
        }
      };
      
      requestAnimationFrame(animateCount);
    }
  }, [inView, endValue, duration]);

  // Use toLocaleString() to format numbers with commas (e.g., 100,000)
  return <div ref={ref}>{count.toLocaleString()}</div>;
};

export default AnimatedCounter;